import { useThemeMode, lightColors, darkColors } from '@/colors';

/**
 * Hook that returns the appropriate color object based on the current theme mode.
 * 
 * @returns The color object for the current theme mode
 * 
 * @example
 * // Get the colors object
 * const colors = useColors();
 * 
 * // Use specific colors
 * <Typography sx={{ color: colors.text.neutral.dark }}>
 *   Text content
 * </Typography>
 */
export const useColors = () => {
  const { mode } = useThemeMode();
  return mode === 'light' ? lightColors : darkColors;
};
